import React, { useCallback, useState } from 'react'
import withPage from 'server/withPage'
import PasswordResetNewPage from 'components/pages/PasswordResetNewPage'
import { bindActionCreators } from 'redux'
import { setUIState, containerIds } from 'redux/modules/ui'

/**
 * @type {React.FC<{
 *  ui: any,
 *  actions: {
 *   setUIState: Function,
 *  },
 *  config: any,
 *  restClient: {
 *    get: (path: string, params: Record<string, unknown>) => Promise<any>,
 *    post: (path: string, params: Record<string, unknown>) => Promise<any>,
 *  },
 * }>}
 */
const Container = props => {
  const { restClient } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isSend, setIsSend] = useState(false)
  const [errorMessages, setErrorMessage] = useState([])
  const passwordResetCreate = useCallback(async email => {
    setIsLoading(true)
    try {
      // 共通のヘッダーを変更してしまっているが、ここ以外でrest使わないので問題ない
      restClient.headers.accept = 'application/json'
      const res = await restClient.post('i/password', { email })
      setIsSend(true)
    } catch (e) {
      if (e?.response?.data?.errors?.email) {
        setErrorMessage(
          e.response.data.errors.email.map(reason => `メールアドレス${reason}`),
        )
      } else {
        // 意図しないエラーの場合はSentryに送る
        Sentry.captureException(e)
        setErrorMessage(['エラーが発生しました。'])
      }
    }
    setIsLoading(false)
  }, [])

  return (
    <PasswordResetNewPage
      {...{
        isLoading,
        isSend,
        errorMessages,
        passwordResetCreate,
        ...props,
      }}
    />
  )
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(Container, mapStateToProps, mapDispatchToProps, {})
